import { type DefaultProps } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import cx from 'classnames'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { twMerge } from 'tailwind-merge'

interface InvestmentOverflowMenuProps extends DefaultProps {
  alias?: string
}

export const InvestmentOverflowMenu: FC<InvestmentOverflowMenuProps> = ({
  className,
  id,
  testId,
  ariaLabel,
  alias,
}) => {
  const { t } = useTranslation('features-investment')

  const navigate = useNavigate()
  // Component base class names. Can be overriden by className property.
  const baseClass = cx('overflow-menu flex flex-col items-start')

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  const INVESTMENT_OVERFLOW_OPTIONS = [
    {
      title: t('account_options.activity'),
      onClick: () => {
        if (alias) {
          void navigate(WEALTH_ROUTES.INVESTMENTS_ACCOUNT_ACTIVITY.path.replace(':alias', alias.toString()))
        }
      },
      key: WEALTH_ROUTES.INVESTMENTS_ACCOUNT_ACTIVITY.path,
    },
    {
      title: t('account_options.statements'),
      onClick: () => {
        void navigate(WEALTH_ROUTES.DOCUMENTS_STATEMENTS.path)
      },
      key: WEALTH_ROUTES.DOCUMENTS_STATEMENTS.path,
    },
    {
      title: t('account_options.tax_documents'),
      onClick: () => {
        void navigate(WEALTH_ROUTES.DOCUMENTS.path)
      },
      key: `${WEALTH_ROUTES.DOCUMENTS.path}-tax-documents`,
    },
    {
      title: t('account_options.trade_confirmations'),
      onClick: () => {
        void navigate(WEALTH_ROUTES.DOCUMENTS.path)
      },
      key: `${WEALTH_ROUTES.DOCUMENTS.path}-trade-confirmations`,
    },
    {
      title: t('account_options.account_details'),
      onClick: () => {
        if (alias) {
          void navigate(WEALTH_ROUTES.INVESTMENTS_ACCOUNT_DETAIL.path.replace(':alias', alias.toString()))
        }
      },
      key: WEALTH_ROUTES.INVESTMENTS_ACCOUNT_DETAIL.path,
    },
    {
      title: t('account_options.account_beneficiaries'),
      onClick: () => {
        void navigate(WEALTH_ROUTES.SETTINGS_BENEFICIARIES.path)
      },
      key: WEALTH_ROUTES.SETTINGS_BENEFICIARIES.path,
    },
  ]

  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      {INVESTMENT_OVERFLOW_OPTIONS.map((option, index) => (
        <button
          data-testid={`investment-overflow-menu-option-${index}`}
          key={option.key}
          className="w-full text-text-body typo-primary-base-regular flex py-sm px-2xs border-b border-light last-of-type:border-none"
          type="button"
          onClick={option.onClick}
        >
          {option.title}
        </button>
      ))}
    </div>
  )
}
